<template>
  <iframe :src="src" frameborder="0"></iframe>
</template>

<script>
import { mapState } from "vuex";

export default {
  breadcrumbData(data) {
    return [...data, { title: this.title }];
  },
  computed: {
    ...mapState(["descriptors"]),
    title: vm =>
      vm.descriptors?.find(d => d.name === vm.$route.params.extension)
        .friendlyName,
    src: vm =>
      process.env.VUE_APP_BASE_API + "extensions/" + vm.$route.params.extension
  }
};
</script>

<style scoped>
iframe {
  width: 100%;
}
</style>
